export {default as EdAlert} from './EdAlert'
export {default as EdForm} from './EdForm'
export {default as EdTabs} from './EdTabs'
export {default as EdTabsPanel} from './EdTabsPanel'
export {default as EdInputText} from './EdInputText'
export {default as EdInputTextArea} from './EdInputTextArea'
export {default as EdInputUpload} from './EdInputUpload'
export {default as EdInputDatePicker} from './EdInputDatePicker'
export {default as EdInputEditor} from './EdInputEditor'
export {default as EdInputSelect} from './EdInputSelect'
export {default as EdInputAutoComplete} from './EdInputAutoComplete'
export {default as EdInputSwitch} from './EdInputSwitch'
export {default as EdInputTipo} from './EdInputTipo'
export {default as EdButton} from './EdButton'
export {default as EdModal} from './EdModal'
export {default as EdNotification} from './EdNotification'
export {default as EdPagination} from './EdPagination'
export {default as EdTable} from './EdTable'




// WEBPACK FOOTER //
// ./src/components/template/index.js